module.exports = "/images/map.png?b9b007e944672fc45f590c574e0ff5c1";